// Countdown 15 minutos
function lmpStartCountdown() {
  var timerEl = document.getElementById('lmpCountdownTimer');
  if (!timerEl) return;
  var secondsLeft = 15 * 60;
  function update() {
    if (secondsLeft <= 0) { timerEl.textContent = "00:00"; return; }
    var mins = Math.floor(secondsLeft / 60);
    var secs = secondsLeft % 60;
    timerEl.textContent = (mins < 10 ? '0' : '') + mins + ':' + (secs < 10 ? '0' : '') + secs;
    secondsLeft--;
    setTimeout(update, 1000);
  }
  update();
}

// Scroll reveal
function lmpInitReveal() {
  var revEls = document.querySelectorAll('.reveal');
  if (!revEls.length) return;
  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.1, rootMargin: '0px 0px -20px 0px' });
  revEls.forEach(function(el) { observer.observe(el); });
}

// FAQ accordion
function lmpInitFaq() {
  var faqItems = document.querySelectorAll('.faq-q');
  if (!faqItems.length) return;
  faqItems.forEach(function(q) {
    q.addEventListener('click', function(e) {
      var item = q.closest('.faq-item');
      var isOpen = item.classList.contains('open');
      document.querySelectorAll('.faq-item.open').forEach(function(i) {
        i.classList.remove('open');
      });
      if (!isOpen) item.classList.add('open');
    });
  });
}

// Inicializar todo cuando el DOM esté listo
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function() {
    lmpStartCountdown();
    lmpInitReveal();
    lmpInitFaq();
  });
} else {
  lmpStartCountdown();
  lmpInitReveal();
  lmpInitFaq();
}
// Carrusel de dos niveles con control manual y auto-scroll
function initGalleryCarousel() {
  const track = document.getElementById('galleryTrack');
  const row1 = document.getElementById('galleryRow1');
  const row2 = document.getElementById('galleryRow2');
  const prevBtn = document.querySelector('.gallery-carousel-btn--prev');
  const nextBtn = document.querySelector('.gallery-carousel-btn--next');
  const dots = document.querySelectorAll('.gallery-carousel-dot');
  
  if (!track || !row1 || !row2) return;
  
  let currentIndex = 0;
  let autoScrollInterval;
  const totalDots = dots.length;
  
  // Velocidades de animación CSS
  const speed1 = 40; // segundos para fila 1
  const speed2 = 45; // segundos para fila 2
  
  // Aplicar velocidades
  row1.style.animation = `scrollRow ${speed1}s linear infinite`;
  row2.style.animation = `scrollRowReverse ${speed2}s linear infinite`;
  
  // Función para cambiar página (no es necesario para scroll infinito, 
  // pero mantenemos los dots como indicadores visuales)
  function updateDots(index) {
    dots.forEach((dot, i) => {
      dot.classList.toggle('active', i === index);
    });
  }
  
  // Cambiar dirección de scroll (opcional - para interacción)
  let isPaused = false;
  
  function pauseAnimation() {
    if (isPaused) return;
    row1.style.animationPlayState = 'paused';
    row2.style.animationPlayState = 'paused';
    isPaused = true;
  }
  
  function resumeAnimation() {
    if (!isPaused) return;
    row1.style.animationPlayState = 'running';
    row2.style.animationPlayState = 'running';
    isPaused = false;
  }
  
  // Navegación manual (con desplazamiento suave)
  function navigate(direction) {
    pauseAnimation();
    const scrollAmount = 280; // ancho aproximado de cada item + gap
    if (direction === 'next') {
      track.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    } else {
      track.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
    }
    
    // Reanudar después de 2 segundos
    clearTimeout(window.resumeTimeout);
    window.resumeTimeout = setTimeout(() => {
      resumeAnimation();
    }, 2000);
  }
  
  // Event listeners para botones
  if (prevBtn) {
    prevBtn.addEventListener('click', () => navigate('prev'));
  }
  if (nextBtn) {
    nextBtn.addEventListener('click', () => navigate('next'));
  }
  
  // Pausar al hacer hover sobre el carrusel
  const carousel = document.querySelector('.gallery-carousel');
  if (carousel) {
    carousel.addEventListener('mouseenter', pauseAnimation);
    carousel.addEventListener('mouseleave', resumeAnimation);
  }
  
  // Rotación automática de dots (solo visual, sin afectar scroll)
  function autoRotateDots() {
    autoScrollInterval = setInterval(() => {
      currentIndex = (currentIndex + 1) % totalDots;
      updateDots(currentIndex);
    }, 5000);
  }
  
  autoRotateDots();
  
  // Cleanup on page unload
  window.addEventListener('beforeunload', () => {
    if (autoScrollInterval) clearInterval(autoScrollInterval);
  });
}

// Inicializar cuando el DOM esté listo
document.addEventListener('DOMContentLoaded', function() {
  // ... tus otras funciones ...
  initGalleryCarousel();
});